import React from "react"
import IcoMoon from "react-icomoon"
import styled from "styled-components"
import { common } from "./_atoms"

const iconSet = require("../../assets/fonts/icons/selection.json")

const Icon = ({ ...props }) => {
  return <StyledIcoMoon className="icon" iconSet={iconSet} {...props} />
}

export default Icon

const StyledIcoMoon = styled(IcoMoon)`
  ${common};
  color: ${({ theme, color }) => theme.color[color] ?? color};
`
